import { clientApplicationListTabs } from '@entities/applicationList';
import { ApplicationList as ApplicationListWithTabs } from './list';

export function ApplicationList() {
  return <ApplicationListWithTabs tabs={clientApplicationListTabs} />;
}
